var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFasterTime(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 7.2V4.6h2.6c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3h-7.7c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3h2.6v2.6c-7.9.7-14.1 7.3-14.1 15.4C11.1 31.1 18 38 26.5 38s15.4-6.9 15.4-15.4c-.1-8.1-6.3-14.7-14.2-15.4zm4.7 11.1l-2.6 2.6c.2.5.4 1.1.4 1.7 0 2.1-1.7 3.9-3.9 3.9-2.1 0-3.9-1.7-3.9-3.9 0-.6.1-1.2.4-1.7l-5.1-5.1c-.5-.5-.5-1.3 0-1.8s1.3-.5 1.8 0l5.1 5.1c.5-.2 1.1-.4 1.7-.4.6 0 1.2.1 1.7.4l2.6-2.6c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.8z",
    fill: "#A6E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 23.9a1.3 1.3 0 100-2.6 1.3 1.3 0 000 2.6z",
    fill: "#A6E5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 29.2c0 .3-.3.6-.6.6H8.3c-.3 0-.6-.3-.6-.6v-3.6c0-.3.3-.6.6-.6h3.6c.3 0 .6.3.6.6v3.6z",
    fill: "#F2A619"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 29.2c0 .3-.3.6-.6.6h-3.7c-.3 0-.6-.3-.6-.6v-3.6c0-.3.3-.6.6-.6h3.6c.3 0 .6.3.6.6v3.6h.1z",
    fill: "#0D4599"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 29.2c0 .3-.3.6-.6.6h-3.6c-.3 0-.6-.3-.6-.6v-3.6c0-.3.3-.6.6-.6h3.6c.3 0 .6.3.6.6v3.6z",
    fill: "#F2A619"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 36.5c0 .3-.3.6-.6.6H8.3c-.3 0-.6-.3-.6-.6v-3.6c0-.3.3-.6.6-.6h3.6c.3 0 .6.3.6.6v3.6zM27.1 36.5c0 .3-.3.6-.6.6h-3.7c-.3 0-.6-.3-.6-.6v-3.6c0-.3.3-.6.6-.6h3.6c.3 0 .6.3.6.6v3.6h.1zM19.8 36.5c0 .3-.3.6-.6.6h-3.6c-.3 0-.6-.3-.6-.6v-3.6c0-.3.3-.6.6-.6h3.6c.3 0 .6.3.6.6v3.6z",
    fill: "#0D4599"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 11.6h-1.2V9.2c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2v2.4H10.1V9.2c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2v2.4H6.5c-2 0-3.6 1.6-3.6 3.6v23.1c0 2 1.6 3.6 3.6 3.6h21.9c2 0 3.6-1.6 3.6-3.6v-23c-.1-2-1.7-3.7-3.7-3.7zM6.4 14.1h1.2v2.4c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2v-2.4h14.6v2.4c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2v-2.4h1.2c.7 0 1.2.5 1.2 1.2v4.9H5.1v-4.9c.1-.7.7-1.2 1.3-1.2zm21.9 25.5H6.4c-.7 0-1.2-.5-1.2-1.2V22.6h24.3v15.8c0 .6-.5 1.2-1.2 1.2z",
    fill: "#0D4599"
  })));
}

export default __webpack_public_path__ + "5b9727847494747272434350f6dd538e.svg";
export { SvgFasterTime as ReactComponent };